import usePermissions from "@/hooks/use-permissions.hook.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { useTranslation } from "react-i18next";
import {
  PerformanceReviewTemplateEditPageStep,
  TemplateEditPageProps,
  useTemplateEditPage,
} from "@/pages/talent/performance-reviews/templates/edit/performance-review-template-edit.tsx";
import { PerformanceReviewTemplateTitleSlot } from "@/pages/talent/performance-reviews/templates/edit/PerformanceReviewTemplateTitleSlot.tsx";
import { PerformanceReviewTemplateEditSidebar } from "../components/PerformanceReviewTemplateEditSidebar.tsx";
import { Button, FullScreenPage, Stack } from "@skailer-com/uikit";
import { FormEditor } from "@/components/forms/FormEditor.tsx";
import { FormEditorTypes } from "@/components/forms/form-editor.config.ts";

export const PerformanceReviewTemplateEditQuestionsPage = ({ template }: TemplateEditPageProps) => {
  const { t } = useTranslation();
  const { exit, confirmExit, navigateToStep } = useTemplateEditPage();
  const { canIEdit } = usePermissions();
  const readOnly = !canIEdit(ApiPermission.performance_review_templates);

  return (
    <FullScreenPage
      backSlot={
        <Button variant={"secondary"} size={"lg"} onClick={readOnly ? exit : confirmExit}>
          {t("common:exit")}
        </Button>
      }
      titleSlot={
        <PerformanceReviewTemplateTitleSlot
          step={PerformanceReviewTemplateEditPageStep.questions}
          template={template}
        />
      }
      isCenterVertical={false}
      contentSize={"md"}
      sidebarSlot={
        <PerformanceReviewTemplateEditSidebar
          step={PerformanceReviewTemplateEditPageStep.questions}
          template={template}
        />
      }
      actionsSlot={
        <>
          <Button
            variant={"secondary"}
            size={"lg"}
            onClick={() => {
              navigateToStep(template.id, PerformanceReviewTemplateEditPageStep.details);
            }}
          >
            {t("common:back")}
          </Button>
          {!readOnly && (
            <Button size={"lg"} onClick={exit}>
              {t("common:save")}
            </Button>
          )}
        </>
      }
    >
      <Stack gap={"lg"}>
        <FormEditor
          type={FormEditorTypes.performanceReviewTemplate}
          id={template.id}
          readOnly={readOnly}
        />
      </Stack>
    </FullScreenPage>
  );
};
